module.exports = __webpack_public_path__ + "media/country_50m.317f494a.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/resources/vector/borders/country_50m.geojson
// module id = 1128
// module chunks = 0